export default (message) => Boolean(message.from?.id)
